export const DateFilterOperator = {
  empty: "isEmpty",
  notEmpty: "isNotEmpty",
  between: "between",
  equals: "equals",
  before: "before",
  after: "after",
  notEquals: "notEquals",
  beforeOrEquals: "isBeforeOrEquals",
  afterOrEquals: "isAfterOrEquals",
  notBetween: "isNotBetween",
} as const

export type DateFilterOperator =
  (typeof DateFilterOperator)[keyof typeof DateFilterOperator]

export type DateFilterDto = {
  operator: DateFilterOperator
  startDate: Date | null
  endDate: Date | null
}
